import { createSlice } from '@reduxjs/toolkit';

const queueMemberSlice = createSlice({
  name: 'queueMembers',
  initialState: {
    queueMembers: [],
    dataValid: false
  },
  reducers: {
    setQueueMembers(state, action) {
      console.count("queueMemberSlice: setQueueMembers");
      if (!action || !action.payload || !action.payload.queueMembers) {
        state.queueMembers = [];
        state.dataValid = false;
        return;
      }

      state.queueMembers = action.payload.queueMembers;
      state.dataValid = !!action.payload.dataValid;
    },
    patchQueueMembers(state, action) {
      if (!action || !action.payload || !action.payload.queueMembers) {
        state.dataValid = false;
        return;
      }

      if (!state.queueMembers) return;

      action.payload.queueMembers.forEach(changedItem => {
        if (!changedItem) return;
        const queueMember = state.queueMembers.find(queueMember => queueMember.queueId === changedItem.queueId);
        if (!queueMember) return;
        if (!queueMember.members) queueMember.members = [];

        if (changedItem.membersToAdd) {
          changedItem.membersToAdd.forEach(addedMember => {
            if (!addedMember) return;
            if (!queueMember.members.find(member => member.id === addedMember.id)) {
              queueMember.members.push(addedMember);
            }
          });
        }

        if (changedItem.membersToDelete) {
          changedItem.membersToDelete.forEach(deletedMember => {
            if (!deletedMember) return;
            queueMember.members = queueMember.members.filter(member => member.id !== deletedMember.id);
          });
        }
      });
    },
    patchQueueActivations(state, action){
      console.log(action);
      if (!action || !action.payload || !action.payload.queueMembers) {
        state.dataValid = false;
        return;
      }

      if (!state.queueMembers) return;

      action.payload.queueMembers.forEach(changedItem => {
        if (!changedItem) return;
        const queueMember = state.queueMembers.find(queueMember => queueMember.queueId === changedItem.queueId);
        if (!queueMember) return;
        if (!queueMember.members) queueMember.members = [];

        if (changedItem.members){
          changedItem.members.forEach(changedMember => {
            if (!changedMember) return;
            let member = queueMember.members.find(member => member.id === changedMember.id);
            if(member){
              member.joined = changedMember.joined;
            }
          });
        }
      });
    },
    invalidateData(state, action) {
      state.dataValid = false;
    }
  },
});

export const queueMemberActions = queueMemberSlice.actions;

export default queueMemberSlice;